<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5 8L10 13L15 8" stroke="#44454D" stroke-width="1.5" stroke-linecap="square"/>
</svg>
